import photo1 from "../../../assets/images/appImages/member-1.png"
import photo2 from "../../../assets/images/appImages/member-2.png"
import photo3 from "../../../assets/images/appImages/member-3.png"
import photo4 from "../../../assets/images/appImages/member-4.png"
import photo5 from "../../../assets/images/appImages/member-5.png"

export const TeamData = [
  {
    id: 1,
    photo: photo1,
    name: "Coutta Badji",
    role: "Directrice générale et Fondatrice",
  },
  {
    id: 3,
    photo: photo2,
    name: "Yaya Touré",
    role: "Responsable des opérations",
  },
  {
    id: 3,
    photo: photo3,
    name: "Ousmane Karafa Badji",
    role: "Responsable logistique",
  },
  {
    id: 4,
    photo: photo4,
    name: "Mamadou Daffé",
    role: "Agent polyvalent et préparateur de commandes",
  },
  {
    id: 5,
    photo: photo5,
    name: "Anne Badji",
    role: "Opératrice de saisie/standardiste",
  },

]
